/*
 * Pizzamateur — fiche produit compacte sur mobile.
 *
 * Deux mécanismes, mobile uniquement (sur ordinateur la page tient sans gêner) :
 *
 *   1. VOLETS (accordéons fermés) sur les blocs de VÉRIFICATION — caractéristiques
 *      techniques, mode d'emploi, livraison & retour. Le client va les chercher
 *      une fois qu'il s'intéresse au produit ; les garder ouverts coûte ~1 100 px
 *      de défilement pour un contenu peu lu.
 *
 *   2. « LIRE LA SUITE » sur les blocs qui VENDENT — description principale et
 *      « Pourquoi ce produit… ». Ceux-là restent visibles : ce qui est replié est
 *      nettement moins lu, et c'est le contenu qui convainc d'acheter.
 *
 * Rien n'est retiré du code : Google indexe normalement le contenu replié
 * (index mobile-first), et les lecteurs d'écran suivent l'état aria-expanded.
 *
 * Générique : repose sur la structure commune à toutes les fiches
 * (section pm-product-info), donc valable pour tout le catalogue.
 */
(function () {
  'use strict';

  var MOBILE = '(max-width: 749px)';
  var HAUTEUR_REPLIEE = 240;
  var compteur = 0;

  /* Blocs mis en volet fermé. Un bloc absent d'une fiche est simplement ignoré. */
  var EN_VOLET = ['.pm-pinfo__carac', '.pm-pinfo__usage', '.pm-pinfo__shipping'];

  function chevron() {
    var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('class', 'pm-volet__chevron');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('fill', 'none');
    svg.setAttribute('stroke', 'currentColor');
    svg.setAttribute('stroke-width', '2.2');
    svg.setAttribute('stroke-linecap', 'round');
    svg.setAttribute('stroke-linejoin', 'round');
    var path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    path.setAttribute('d', 'M6 9l6 6 6-6');
    svg.appendChild(path);
    return svg;
  }

  /* ---------- 1. volets ---------- */
  function enVolet(bloc) {
    if (!bloc || bloc.getAttribute('data-pm-volet')) return;
    var titre = bloc.querySelector('.pm-pinfo__h2');
    if (!titre) return;

    bloc.setAttribute('data-pm-volet', '1');
    bloc.classList.add('pm-volet', 'pm-volet--ferme');

    /* On regroupe tout sauf le titre dans un conteneur repliable. */
    var contenu = document.createElement('div');
    contenu.className = 'pm-volet__contenu';
    contenu.id = 'pm-volet-' + ++compteur;

    var aDeplacer = [];
    for (var i = 0; i < bloc.children.length; i++) {
      if (bloc.children[i] !== titre) aDeplacer.push(bloc.children[i]);
    }
    if (!aDeplacer.length) return;
    aDeplacer.forEach(function (e) { contenu.appendChild(e); });
    bloc.appendChild(contenu);

    /* Le titre reste un h2 (structure de la page préservée pour Google) ;
       on place le bouton à l'intérieur. */
    var bouton = document.createElement('button');
    bouton.type = 'button';
    bouton.className = 'pm-volet__btn';
    bouton.setAttribute('aria-expanded', 'false');
    bouton.setAttribute('aria-controls', contenu.id);
    while (titre.firstChild) bouton.appendChild(titre.firstChild);
    bouton.appendChild(chevron());
    titre.appendChild(bouton);

    bouton.addEventListener('click', function () {
      var ferme = bloc.classList.toggle('pm-volet--ferme');
      bouton.setAttribute('aria-expanded', ferme ? 'false' : 'true');
      if (ferme) titre.scrollIntoView({ block: 'nearest' });
    });
  }

  /* ---------- 1 bis. bénéfices en haut de fiche ----------
     Entre les étoiles et le prix, il n'y avait aucun argument : le client
     passait du titre au prix. On remonte 4 bénéfices courts, pris dans la
     liste à puces que chaque fiche possède déjà — ce sont les mots de la
     fiche, rien n'est reformulé ici. */
  function coche() {
    var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('class', 'pm-plus__icon');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('fill', 'none');
    svg.setAttribute('stroke', 'currentColor');
    svg.setAttribute('stroke-width', '2.6');
    svg.setAttribute('stroke-linecap', 'round');
    svg.setAttribute('stroke-linejoin', 'round');
    var path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    path.setAttribute('d', 'M20 6L9 17l-5-5');
    svg.appendChild(path);
    return svg;
  }

  /* Format le plus fréquent : « Bénéfice court — explication ». À défaut, le
     passage en gras. En dernier recours, une troncature sur un mot entier. */
  function texteCourt(li) {
    var brut = (li.textContent || '').replace(/\s+/g, ' ').trim();
    var parts = brut.split(/\s*[—–]\s*|\s:\s/);
    if (parts.length > 1 && parts[0].length >= 6 && parts[0].length <= 42) return parts[0].trim();
    /* Le gras seul ne suffit que s'il dit quelque chose : sur certaines fiches
       il vaut « Perforations » ou « Compatible », ce qui ne vend rien. En
       dessous de 16 caractères on préfère la phrase entière. */
    var gras = li.querySelector('strong, b');
    if (gras) {
      var t = gras.textContent.replace(/\s+/g, ' ').trim().replace(/\s*[:—–]\s*$/, '');
      if (t.length >= 16 && t.length <= 46) return t;
    }
    if (brut.length <= 46) return brut;
    var coupe = brut.slice(0, 46);
    return coupe.slice(0, coupe.lastIndexOf(' ')) + '…';
  }

  /* ⚠️ Sans ces deux filtres, on récupère la liste des MOYENS DE PAIEMENT
     (American Express, Apple Pay…), présente sur toutes les fiches. */
  function listeDesBenefices(details) {
    return Array.prototype.slice
      .call(details.querySelectorAll('[class*="text-block"] ul'))
      .filter(function (u) {
        if (u.closest('[class*="payment"]')) return false;
        var li = Array.prototype.slice.call(u.querySelectorAll('li'));
        return li.length >= 3 && li.filter(function (x) {
          return (x.textContent || '').trim().length > 12;
        }).length >= 3;
      })[0] || null;
  }

  /* ---------- 1 ter. LES 3 BÉNÉFICES CLÉS (05/10/2026) ----------
     Quand la fiche a son métachamp « fiche.benefices » (une ligne par
     bénéfice, écrit pour le client), on affiche ces lignes en grand sous le
     prix, sur téléphone ET sur ordinateur, à la place des 4 petits points
     tirés automatiquement de la description. Le texte arrive par le
     <script id="pm-benefices"> posé dans layout/theme.liquid.
     Une ligne peut s'écrire « Bénéfice — précision » : la précision passe
     alors en plus petit dessous. */
  function beneficesCles() {
    var details = document.querySelector('.product-details');
    if (!details || details.querySelector('.pm-plus--cles')) return;
    var source = document.getElementById('pm-benefices');
    if (!source) return;
    var lignes = [];
    try { lignes = JSON.parse(source.textContent || '[]'); } catch (e) { return; }
    lignes = lignes.map(function (l) { return String(l || '').replace(/\s+/g, ' ').trim(); })
      .filter(Boolean).slice(0, 3);
    if (lignes.length < 2) return;

    var ancien = details.querySelector('.pm-plus');
    if (ancien) ancien.remove();

    var ul = document.createElement('ul');
    ul.className = 'pm-plus pm-plus--cles';
    lignes.forEach(function (t) {
      var parts = t.split(/\s+[—–]\s+/);
      var li = document.createElement('li');
      li.className = 'pm-plus__item';
      li.appendChild(coche());
      var span = document.createElement('span');
      span.className = 'pm-plus__txt';
      var fort = document.createElement('strong');
      fort.textContent = parts[0];
      span.appendChild(fort);
      if (parts.length > 1) {
        var detail = document.createElement('small');
        detail.textContent = parts.slice(1).join(' — ');
        span.appendChild(detail);
      }
      li.appendChild(span);
      ul.appendChild(li);
    });

    var prix = details.querySelector('product-price');
    var cible = prix ? (prix.closest('.group-block') || prix) : null;
    if (cible && cible.parentNode) cible.parentNode.insertBefore(ul, cible.nextSibling);
  }

  function benefices() {
    var details = document.querySelector('.product-details');
    if (!details || details.querySelector('.pm-plus')) return;

    var liste = listeDesBenefices(details);
    if (!liste) return;

    var textes = Array.prototype.slice.call(liste.querySelectorAll('li'))
      .slice(0, 4).map(texteCourt).filter(Boolean);
    if (textes.length < 2) return;

    var ul = document.createElement('ul');
    ul.className = 'pm-plus';
    textes.forEach(function (t) {
      var li = document.createElement('li');
      li.className = 'pm-plus__item';
      li.appendChild(coche());
      var span = document.createElement('span');
      span.textContent = t;
      li.appendChild(span);
      ul.appendChild(li);
    });

    /* Juste APRÈS le bloc prix (qui porte aussi « Livraison gratuite »),
       avant le choix de la couleur et de la taille. */
    var prix = details.querySelector('product-price');
    var cible = prix ? (prix.closest('.group-block') || prix) : null;
    if (cible && cible.parentNode) cible.parentNode.insertBefore(ul, cible.nextSibling);
  }

  /* ---------- 1 quater. AVIS MIS EN AVANT (06/10/2026) ----------
     Bloc « Ce qu'en disent les acheteurs » sous les garanties : 3 avis
     choisis avec Jérôme, la note du produit et un lien vers tous les avis.
     Les avis viennent du métachamp fiche.avis_vedettes (JSON : nom, note,
     pizzamateur, texte), posé dans <script id="pm-avis"> par theme.liquid.
     Règles : texte repris MOT POUR MOT ; prénom + initiale ; jamais le mot
     « vérifié » sur un avis importé ; seul un vrai client de la boutique
     (pizzamateur: true) porte la mention « Acheteur Pizzamateur ». */
  function etoiles(note) {
    var s = document.createElement('span');
    s.className = 'pm-avis__etoiles';
    s.setAttribute('role', 'img');
    s.setAttribute('aria-label', note + ' sur 5');
    var n = Math.max(0, Math.min(5, Math.round(note)));
    s.textContent = '★★★★★'.slice(0, n) + '☆☆☆☆☆'.slice(0, 5 - n);
    return s;
  }

  function avisVedettes() {
    var details = document.querySelector('.product-details');
    if (!details || details.querySelector('.pm-avis')) return;
    var source = document.getElementById('pm-avis');
    if (!source) return;
    var data;
    try { data = JSON.parse(source.textContent || '{}'); } catch (e) { return; }
    var liste = (data && data.avis) || [];
    if (!liste.length) return;
    /* Emplacement (06/10/2026, demande Jérôme) : juste APRÈS la description
       du produit (le bloc de texte qui suit les garanties). À défaut, sous les
       garanties comme avant. Le bouton « Lire la suite » du repli mobile, posé
       plus tard par replier(), vient se glisser entre la description et nous. */
    var ancre = details.querySelector('[class*="ai-trust-badges"] ~ rte-formatter') ||
      details.querySelector('[class*="ai-trust-badges"] ~ .rte') ||
      /* gabarits où la description n'est pas un rte-formatter (pelle perforée,
         thermomètre infrarouge) : le premier bloc de texte après les garanties */
      details.querySelector('[class*="ai-trust-badges"] ~ .text-block') ||
      details.querySelector('[class*="ai-trust-badges"]') ||
      details.querySelector('.payment-icons') || details.querySelector('.buy-buttons-block');
    if (!ancre || !ancre.parentNode) return;

    var bloc = document.createElement('section');
    bloc.className = 'pm-avis';
    bloc.setAttribute('aria-label', 'Avis mis en avant');

    var titre = document.createElement('h2');
    titre.className = 'pm-avis__titre';
    titre.textContent = "Ce qu'en disent les acheteurs";
    bloc.appendChild(titre);

    if (data.note && data.total) {
      var resume = document.createElement('p');
      resume.className = 'pm-avis__resume';
      resume.appendChild(etoiles(data.note));
      var chiffre = document.createElement('span');
      /* une seule décimale : 4,7 et non 4,71 (demande Jérôme) */
      chiffre.textContent = Number(data.note).toFixed(1).replace('.', ',') + '/5 · ' + data.total + ' avis';
      resume.appendChild(chiffre);
      bloc.appendChild(resume);
    }

    var ul = document.createElement('ul');
    ul.className = 'pm-avis__liste';
    liste.slice(0, 3).forEach(function (a) {
      if (!a || !a.texte) return;
      var li = document.createElement('li');
      li.className = 'pm-avis__item';
      li.appendChild(etoiles(a.note || 5));
      var q = document.createElement('p');
      q.className = 'pm-avis__texte';
      q.textContent = '« ' + String(a.texte).trim() + ' »';
      li.appendChild(q);
      var qui = document.createElement('p');
      qui.className = 'pm-avis__auteur';
      qui.appendChild(document.createTextNode(a.nom || ''));
      if (a.pizzamateur) {
        var tag = document.createElement('span');
        tag.className = 'pm-avis__tag';
        tag.textContent = 'Acheteur Pizzamateur';
        qui.appendChild(tag);
      }
      li.appendChild(qui);
      ul.appendChild(li);
    });
    bloc.appendChild(ul);

    /* Sur téléphone, les avis défilent un par un de gauche à droite (CSS
       scroll-snap) : ces points disent combien il y en a et lequel on lit. */
    var cartes = ul.children;
    if (cartes.length > 1) {
      var points = document.createElement('div');
      points.className = 'pm-avis__points';
      var boutons = [];
      Array.prototype.forEach.call(cartes, function (carte, i) {
        var pt = document.createElement('button');
        pt.type = 'button';
        pt.className = 'pm-avis__point' + (i === 0 ? ' is-active' : '');
        pt.setAttribute('aria-label', 'Avis ' + (i + 1) + ' sur ' + cartes.length);
        pt.addEventListener('click', function () {
          ul.scrollTo({ left: carte.offsetLeft - ul.offsetLeft, behavior: 'smooth' });
        });
        boutons.push(pt);
        points.appendChild(pt);
      });
      var attente = null;
      ul.addEventListener('scroll', function () {
        if (attente) return;
        attente = setTimeout(function () {
          attente = null;
          var proche = 0, ecart = Infinity;
          Array.prototype.forEach.call(cartes, function (carte, i) {
            var e = Math.abs((carte.offsetLeft - ul.offsetLeft) - ul.scrollLeft);
            if (e < ecart) { ecart = e; proche = i; }
          });
          boutons.forEach(function (pt, i) { pt.classList.toggle('is-active', i === proche); });
        }, 80);
      }, { passive: true });
      bloc.appendChild(points);
    }

    if (data.total) {
      var lien = document.createElement('a');
      lien.className = 'pm-avis__lien';
      lien.href = '#judgeme_product_reviews';
      lien.textContent = 'Voir les ' + data.total + ' avis';
      lien.addEventListener('click', function (e) {
        var cible = document.querySelector('.jdgm-review-widget, #judgeme_product_reviews');
        if (!cible) return;
        e.preventDefault();
        cible.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
      bloc.appendChild(lien);
    }

    var mention = document.createElement('p');
    mention.className = 'pm-avis__mention';
    mention.textContent = "Avis recueillis auprès d'acheteurs du même produit.";
    bloc.appendChild(mention);

    ancre.parentNode.insertBefore(bloc, ancre.nextSibling);
  }

  /* ---------- 2. « Lire la suite » ---------- */
  function replier(contenu) {
    if (!contenu || contenu.getAttribute('data-pm-replie')) return;
    /* Inutile d'ajouter un bouton s'il ne masque presque rien. */
    if (contenu.scrollHeight < HAUTEUR_REPLIEE + 120) return;

    contenu.setAttribute('data-pm-replie', '1');
    var hote = contenu.parentNode;
    hote.classList.add('pm-lire', 'pm-lire--replie');

    var bouton = document.createElement('button');
    bouton.type = 'button';
    bouton.className = 'pm-lire__btn';
    bouton.setAttribute('aria-expanded', 'false');
    bouton.textContent = 'Lire la suite';
    if (contenu.id) bouton.setAttribute('aria-controls', contenu.id);

    bouton.addEventListener('click', function () {
      var estReplie = hote.classList.toggle('pm-lire--replie');
      bouton.setAttribute('aria-expanded', estReplie ? 'false' : 'true');
      bouton.textContent = estReplie ? 'Lire la suite' : 'Réduire';
      if (estReplie) hote.scrollIntoView({ block: 'start', behavior: 'smooth' });
    });

    contenu.insertAdjacentElement('afterend', bouton);
  }

  /* La longue description du bloc d'achat n'a pas de classe propre : on prend
     le bloc de texte le plus haut, en excluant celui qui porte le titre. */
  function descriptionPrincipale() {
    var details = document.querySelector('.product-details');
    if (!details) return null;
    var candidats = Array.prototype.slice
      .call(details.querySelectorAll('.text-block'))
      .filter(function (e) {
        return !e.querySelector('h1') && e.getBoundingClientRect().height > 300;
      });
    candidats.sort(function (a, b) {
      return b.getBoundingClientRect().height - a.getBoundingClientRect().height;
    });
    return candidats[0] || null;
  }

  function poser() {
    beneficesCles(); /* toutes largeurs d'écran */
    avisVedettes(); /* toutes largeurs d'écran */

    if (!window.matchMedia(MOBILE).matches) return;

    EN_VOLET.forEach(function (sel) { enVolet(document.querySelector(sel)); });

    benefices();

    replier(document.querySelector('.pm-pinfo__details-content'));

    var desc = descriptionPrincipale();
    if (desc) {
      /* On replie le contenu interne, pour que le bouton se place sous le texte. */
      var interne = desc.firstElementChild && desc.children.length === 1
        ? desc.firstElementChild
        : desc;
      replier(interne);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', poser);
  } else {
    poser();
  }

  /* Une page ouverte en format ordinateur puis passée en format téléphone
     (rotation d'une tablette, fenêtre redimensionnée) doit aussi en profiter :
     sans cela, le script ne s'exécute qu'une fois et ne voit jamais le mobile.
     poser() est protégée contre les doublons par ses marqueurs data-*. */
  var mq = window.matchMedia(MOBILE);
  if (mq.addEventListener) {
    mq.addEventListener('change', function (e) { if (e.matches) poser(); });
  } else if (mq.addListener) {
    mq.addListener(function (e) { if (e.matches) poser(); });
  }
})();
